var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { focusOutline } from '../../../../styles/style-mixins';
const baseStyles = () => css `
  vertical-align: middle;

  tbody & {
    &:last-child {
      th,
      td {
        border-bottom: none;
      }
    }
  }
`;
// Chrome doesn't respect position: relative; on table elements
// so the transform property is used to create a separate stacking context
// which is needed to show the focus outline above the other table rows.
const clickableStyles = ({ onClick }) => onClick &&
    css `
    cursor: pointer;
    position: relative;

    &:focus {
      z-index: 1;
      transform: translate(0, 0);
      ${focusOutline()};
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }

    tbody &:focus,
    tbody &:hover {
      td,
      th {
        color: var(--cui-fg-accent-hovered);
        background-color: var(--cui-bg-normal-hovered);
      }
    }

    tbody &:active {
      td,
      th {
        color: var(--cui-fg-accent-pressed);
        background-color: var(--cui-bg-normal-pressed);
      }
    }
  `;
const Tr = styled.tr(baseStyles, clickableStyles);
/**
 * TableRow for the Table component. The Table handles rendering it.
 */
const TableRow = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return _jsx(Tr, Object.assign({ onClick: onClick, tabIndex: onClick ? 0 : undefined }, props));
};
export default TableRow;
